// Name of the ecommerce product option that carries the page count. Kept in its
// own module so selectors can read it without importing (and thus pulling in, or
// being broken by test mocks of) the page-count operation.
export const ECOMMERCE_PAGE_COUNT_CONTROL_NAME = 'Page count';
